export enum MilitaryStatus {
  WAITING = 1,
  DELAYED = 2,
  DONE = 3,
}
